import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SwitchRadio.scss";
import { combineClasses } from "../../utils/css-utils";

interface Option
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  Label: (() => JSX.Element) | string | number;
}

export interface RadioProps {
  options?: Option[];
}
export const SwitchRadio: React.FC<RadioProps> = ({ options }) => {
  return (
    <div className="switch-radio-section">
      <div className="btn-group" data-toggle="buttons">
        {options?.map((option, index) => {
          const { Label, checked, className, ...rest } = option;
          return (
            <label
              key={index}
              onClick={
                rest.onClick as
                  | React.MouseEventHandler<HTMLLabelElement>
                  | undefined
              }
              className={combineClasses(
                className,
                `btn btn-primary small-content d-flex`,
                checked ? "active" : ""
              )}
            >
              <input type="radio" autoComplete="off" {...rest} />
              {typeof Label === "function" ? Label() : Label}
            </label>
          );
        })}
      </div>
    </div>
  );
};

//this is example
SwitchRadio.defaultProps = {
  options: [
    {
      value: "list",
      Label: () => (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.5 5C2.83152 5 3.14946 4.8683 3.38388 4.63388C3.6183 4.39946 3.75 4.08152 3.75 3.75C3.75 3.41848 3.6183 3.10054 3.38388 2.86612C3.14946 2.6317 2.83152 2.5 2.5 2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75C1.25 4.08152 1.3817 4.39946 1.61612 4.63388C1.85054 4.8683 2.16848 5 2.5 5ZM7.1875 3.125C6.93886 3.125 6.7004 3.22377 6.52459 3.39959C6.34877 3.5754 6.25 3.81386 6.25 4.0625C6.25 4.31114 6.34877 4.5496 6.52459 4.72541C6.7004 4.90123 6.93886 5 7.1875 5H17.8125C18.0611 5 18.2996 4.90123 18.4754 4.72541C18.6512 4.5496 18.75 4.31114 18.75 4.0625C18.75 3.81386 18.6512 3.5754 18.4754 3.39959C18.2996 3.22377 18.0611 3.125 17.8125 3.125H7.1875ZM7.1875 9.375C6.93886 9.375 6.7004 9.47377 6.52459 9.64959C6.34877 9.8254 6.25 10.0639 6.25 10.3125C6.25 10.5611 6.34877 10.7996 6.52459 10.9754C6.7004 11.1512 6.93886 11.25 7.1875 11.25H17.8125C18.0611 11.25 18.2996 11.1512 18.4754 10.9754C18.6512 10.7996 18.75 10.5611 18.75 10.3125C18.75 10.0639 18.6512 9.8254 18.4754 9.64959C18.2996 9.47377 18.0611 9.375 17.8125 9.375H7.1875ZM7.1875 15.625C6.93886 15.625 6.7004 15.7238 6.52459 15.8996C6.34877 16.0754 6.25 16.3139 6.25 16.5625C6.25 16.8111 6.34877 17.0496 6.52459 17.2254C6.7004 17.4012 6.93886 17.5 7.1875 17.5H17.8125C18.0611 17.5 18.2996 17.4012 18.4754 17.2254C18.6512 17.0496 18.75 16.8111 18.75 16.5625C18.75 16.3139 18.6512 16.0754 18.4754 15.8996C18.2996 15.7238 18.0611 15.625 17.8125 15.625H7.1875ZM3.75 10C3.75 10.3315 3.6183 10.6495 3.38388 10.8839C3.14946 11.1183 2.83152 11.25 2.5 11.25C2.16848 11.25 1.85054 11.1183 1.61612 10.8839C1.3817 10.6495 1.25 10.3315 1.25 10C1.25 9.66848 1.3817 9.35054 1.61612 9.11612C1.85054 8.8817 2.16848 8.75 2.5 8.75C2.83152 8.75 3.14946 8.8817 3.38388 9.11612C3.6183 9.35054 3.75 9.66848 3.75 10ZM2.5 17.5C2.83152 17.5 3.14946 17.3683 3.38388 17.1339C3.6183 16.8995 3.75 16.5815 3.75 16.25C3.75 15.9185 3.6183 15.6005 3.38388 15.3661C3.14946 15.1317 2.83152 15 2.5 15C2.16848 15 1.85054 15.1317 1.61612 15.3661C1.3817 15.6005 1.25 15.9185 1.25 16.25C1.25 16.5815 1.3817 16.8995 1.61612 17.1339C1.85054 17.3683 2.16848 17.5 2.5 17.5Z"
          />
        </svg>
      ),
    },
    {
      value: "Custom",
      Label: "haha lol",
    },
  ],
};
